import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import RigDetailPage from "@/pages/RigDetailPage";
import FlightSheetsPage from "@/pages/FlightSheetsPage";
import OcProfilesPage from "@/pages/OcProfilesPage";
import AgentInstallPage from "@/pages/AgentInstallPage";
import SettingsPage from "@/pages/SettingsPage";
import ActivityPage from "@/pages/ActivityPage";
import MetricsPage from "@/pages/MetricsPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#09090B]">
        <div className="font-mono text-sm text-[#A1A1AA] tracking-widest">
          LOADING WARTHIVE…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function RedirectIfAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <RedirectIfAuth>
            <LoginPage />
          </RedirectIfAuth>
        }
      />
      <Route
        path="/"
        element={
          <Protected>
            <DashboardPage />
          </Protected>
        }
      />
      <Route
        path="/rigs/:rigId"
        element={
          <Protected>
            <RigDetailPage />
          </Protected>
        }
      />
      <Route
        path="/flight-sheets"
        element={
          <Protected>
            <FlightSheetsPage />
          </Protected>
        }
      />
      <Route
        path="/oc-profiles"
        element={
          <Protected>
            <OcProfilesPage />
          </Protected>
        }
      />
      <Route
        path="/agent"
        element={
          <Protected>
            <AgentInstallPage />
          </Protected>
        }
      />
      <Route
        path="/metrics"
        element={
          <Protected>
            <MetricsPage />
          </Protected>
        }
      />
      <Route
        path="/activity"
        element={
          <Protected>
            <ActivityPage />
          </Protected>
        }
      />
      <Route
        path="/settings"
        element={
          <Protected>
            <SettingsPage />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#18181B",
              border: "1px solid #27272A",
              color: "#FAFAFA",
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
